<script>
    import { onMount } from "svelte";
    import Modal from "../../common/modal/App.svelte";

    let { onCloseHelp } = $props();
    let currentId = $state(1);
    let images = $state([]);

    const LANG = {
        TITLE: "Centro de ayuda",
        TXT_IMG_1: "Enlace referido",
        TXT_IMG_2: "Configuración de Stripe",
        TXT_IMG_3: "Enlace de productos",
        DESCRIPTION_IMG_1: "<h3>Titulo</h3><p>Descripción de la imagen 1.</p>",
        DESCRIPTION_IMG_2: "<h3>Titulo</h3><p>Descripción de la imagen 2.</p>",
        DESCRIPTION_IMG_3: "<h3>Titulo</h3><p>Descripción de la imagen 3.</p>",
        DESCRIPTION_IMG_4: "<h3>Titulo</h3><p>Descripción de la imagen 4.</p>",
    };

    const LIST = [
        {
            text: LANG.TXT_IMG_1,
            id: 1,
            action: () => (
                (images = [{ img: "1", description: LANG.DESCRIPTION_IMG_1 }]),
                (currentId = 1)
            ),
        },
        {
            text: LANG.TXT_IMG_2,
            id: 2,
            action: () => (
                (images = [
                    { img: "2", description: LANG.DESCRIPTION_IMG_2 },
                    { img: "3", description: LANG.DESCRIPTION_IMG_3 },
                ]),
                (currentId = 2)
            ),
        },
        {
            text: LANG.TXT_IMG_3,
            id: 3,
            action: () => (
                (images = [{ img: "4", description: LANG.DESCRIPTION_IMG_4 }]),
                (currentId = 3)
            ),
        },
    ];

    onMount(() => {
        images = [{ img: "1", description: LANG.DESCRIPTION_IMG_1 }];
    });
</script>

{#snippet content()}
    <div class="help">
        <ul>
            {#each LIST as item}
                <li
                    class={item.id === currentId ? "--active" : ""}
                    onclick={item.action}
                >
                    {item.text}
                </li>
            {/each}
        </ul>
        <div class="help__images">
            {#each images as image}
                <div class="help__imageContent">
                    {@html image.description}
                    <img
                        src={`/assets/img/help/help_${image.img}.jpg`}
                        alt={image.text}
                    />
                </div>
            {/each}
        </div>
    </div>
{/snippet}

<Modal
    centered={true}
    isModalOpen={true}
    {content}
    title={LANG.TITLE}
    className="modalHelp"
    onClose={() => onCloseHelp()}
/>

<style lang="scss">
    @import "./styles/index.scss";
</style>
